<template>
  <v-app-bar
    :height="height"
    :class="[
      standalone ? 'standalone' : hiddenDrawer ? 'with-btn' : 'without-btn',
      dense ? 'header-dense' : '',
      contentAligned ? 'content-aligned' : ''
    ]"
    flat
    color="rgba(255,255,255,0)"
  >
    <div class="header-content">
      <p
        v-if="eyebrow"
        class="header-eyebrow mb-1"
        :style="textColorStyle"
      >
        {{ eyebrow }}
      </p>
      <v-toolbar-title :style="textColorStyle" class="header-title">
        {{ title }}
      </v-toolbar-title>
      <p
        v-if="subtitle"
        class="header-subtitle mb-0 mt-2"
        :style="textColorStyle"
      >
        {{ subtitle }}
      </p>
    </div>
    <v-spacer></v-spacer>
    <div v-if="$slots.actions" class="header-actions">
      <slot name="actions"></slot>
    </div>
  </v-app-bar>
</template>
 
<script>
export default {
  name: "Header",
  props: {
    title: String,
    titleColor: String,
    subtitle: String,
    eyebrow: String,
    contentAligned: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    standalone: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hiddenDrawer() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    height() {
      return this.dense ? 88 : 120;
    },
    textColorStyle() {
      return this.titleColor ? `color: ${this.titleColor};` : "";
    }
  }  
  
};
</script>

<style scoped>
.without-btn {
  margin-left: 20px;
}

.with-btn {
  margin-left: 70px;
}

.standalone {
  margin-left: 0;
  padding: 0 16px;
}

.header-dense.without-btn {
  margin-left: 16px;
}

.header-dense.with-btn {
  margin-left: 56px;
}

.header-content {
  min-width: 0;
}

@media only screen and (min-width: 1264px) {
  .content-aligned .header-content {
    margin-left: 28px;
  }
}

.header-title {
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
  white-space: normal;
  word-break: break-word;
}

.header-eyebrow {
  color: #6f7782;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}

.header-subtitle {
  color: #5f6874;
  font-size: 14px;
  line-height: 1.5;
  max-width: 760px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 24px;
}

@media only screen and (max-width: 570px) {
  .header-title {
    font-size: 22px;
  }

  .header-actions {
    margin-right: 12px;
  }
}
</style>
